module.exports = __webpack_public_path__ + "static/media/thenewyou.2d065312.png";